module.exports = __webpack_public_path__ + "img/VP-UltraLine-Assembly.a9a19951.jpg";